export default __webpack_public_path__ + "static/media/morningDisabled.bc4ba757.svg";